import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { CalendarIcon } from "../../lib/icons";
import { Answer } from "../messages/Answer";
import { iaGoToModule } from "./actions";
import { BackendModuleTypes } from "../../lib/types";
import { fadeInAnimation } from "../../lib/animations";
import { noAnimation } from "../../lib/utils";
import { deepChange } from "../../actions";

export const QuickActions = (props) => {
  const dispatch = useDispatch();

  const onScheduleTourClick = () => {
    dispatch(iaGoToModule(BackendModuleTypes.OPEN_SCHEDULE_TOUR));
  };

  const onFocusInput = () => {
    dispatch(deepChange({ "ia.showQuickActions": false }));
    window.famIAinput && window.famIAinput.focus();
  };

  return (
    <QuickActionsWrapper>
      <QuickActionsHeader>What else can we help with?</QuickActionsHeader>
      <QuickActionsItems>
        <Answer onClick={onScheduleTourClick}>
          <CalendarIcon />
          <QuickActionLabel>Schedule a tour</QuickActionLabel>
        </Answer>
        <Answer onClick={onFocusInput}>Ask Another Question</Answer>
      </QuickActionsItems>
    </QuickActionsWrapper>
  );
};

const QuickActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 0 16px;
  opacity: 0;
  animation: ease 0.1s ${noAnimation ? 0 : 1}s forwards ${fadeInAnimation};
`;
const QuickActionsHeader = styled.div`
  color: #595d61;
`;

const QuickActionsItems = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${Answer} {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    flex-basis: 48%;

    background-color: ${(props) => props.theme.brandColor};
    color: white;
  }
`;

const QuickActionLabel = styled.div`
  margin-left: 8px;
`;
